import { Phone, MessageSquare, FileText } from "lucide-react";
import { BIZ } from "@/data/business";
import { scrollToId } from "./SmoothScroll";

export const StickyBar = () => (
  <div data-testid="mobile-sticky-bar" className="md:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-3 bg-[#07080B]/90 backdrop-blur-xl border-t border-white/10 pb-[env(safe-area-inset-bottom)]">
    <a href={BIZ.tel} data-testid="sticky-call" className="flex flex-col items-center justify-center gap-1 h-16 text-xs"><Phone className="h-5 w-5 text-[#1bb4f2]" />Call</a>
    <a href={BIZ.sms} data-testid="sticky-text" className="flex flex-col items-center justify-center gap-1 h-16 text-xs border-x border-white/10"><MessageSquare className="h-5 w-5 text-[#1bb4f2]" />Text</a>
    <button onClick={() => scrollToId("quote")} data-testid="sticky-quote" className="flex flex-col items-center justify-center gap-1 h-16 text-xs bg-[#1bb4f2] text-[#07080B] font-semibold"><FileText className="h-5 w-5" />Quote</button>
  </div>
);
